import { ForwardedRef, forwardRef } from "react";
import RadioButtonGroup, {
  RadioButton,
  RadioButtonGroupProps,
} from "components/Shared/Forms/RadioButtonGroup";
import {
  BaseRadioOptionsSelectProps,
  useRadioOptionsSelect,
} from "components/Shared/Forms/RadioOptionsSelect";

export type RadioButtonOptionsSelectProps<TOptions> = Omit<
  RadioButtonGroupProps,
  "children" | "value" | "onChange"
> &
  BaseRadioOptionsSelectProps<TOptions>;

function RadioButtonOptionsSelect<TOptions>(
  {
    getLabel,
    labels,
    onChange,
    options,
    value,
    ...rest
  }: RadioButtonOptionsSelectProps<TOptions>,
  ref: ForwardedRef<HTMLDivElement>,
) {
  const { fullOptions, handleChange, strValue } = useRadioOptionsSelect({
    getLabel,
    labels,
    onChange,
    options,
    value,
  });
  return (
    <RadioButtonGroup
      ref={ref}
      value={strValue}
      onChange={handleChange}
      {...rest}
    >
      {fullOptions.map((option) => (
        <RadioButton key={option.value} value={option.value}>
          {option.label}
        </RadioButton>
      ))}
    </RadioButtonGroup>
  );
}

export default forwardRef(RadioButtonOptionsSelect);
